import {FieldValues} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import {GenericFormBGContainer, GenericForm} from "@/components/GenericForm.tsx";
import {Divider} from "@/components/misc.tsx";
import {Input} from "@/components/_Shared/Form/Inputs/Input.tsx";
import {FormGroup, FormChild} from "@/components/_Shared/Form/Containers/FormGroup.tsx";
import {SearchSelect} from "@/components/_Shared/Form/Inputs/SearchSelect.tsx";
import {Button} from "@/components/_Shared/Button.tsx";
import {Submit} from "@/components/_Shared/Form/Buttons/Submit.tsx";
import {FormHookDefaults} from "@/components/_Shared/Form/Interfaces/BasePropFormHookDefaults.ts";
import { FormFetchDataProps } from "@/components/_Shared/Form/Interfaces/FormFetchData";


type PointOfContactBaseProps<TFormValues extends FieldValues> = {
    client_list: FormFetchDataProps[]
    method: "POST" | "PUT"
} & FormHookDefaults<TFormValues>

export function PointOfContactFormBase<TFormValues extends FieldValues>({
    register, errors, control, client_list,
    onSubmit, method, isProcessing
                                       }: PointOfContactBaseProps<TFormValues>) {
    const navigate = useNavigate()

    return(
        <GenericForm form_id="point_contact" onSubmit={onSubmit}>
            <GenericFormBGContainer>
                <h2 className={"text-2xl font-bold"}>{method === "POST" ? "Create" : "Update"} Point of Contact</h2>

                <Divider />

                <Input label={"Name"} name={"name"} type={"text"} register={register} required />
                {errors.name && <p className={"text-red-500"}>{String(errors.name.message)}</p> }

                <FormGroup>
                    <FormChild>
                        <Input label={"E-mail"} name={"email"} type={"text"} register={register} />
                        {errors.email && <p className={"text-red-500"}>{errors.email.message}</p> }
                    </FormChild>

                    <FormChild>
                        <Input label={"Phone Number"} name={"phone_number"} type={"text"} register={register} />
                        {errors.phone_number && <p className={"text-red-500"}>{errors.phone_number.message}</p>}
                    </FormChild>
                </FormGroup>

                <SearchSelect optional label={"Related Client"} name={"client_name"} control={control} options={client_list} />
                {errors.client_name && <p className={"text-red-500"}>{errors.client_name.message}</p>}

                <FormGroup>
                    <Button onClick={() => navigate("/point_of_contact/list")}>Cancel</Button>
                    <Submit isSubmitting={isProcessing} label="Submit" />
                </FormGroup>
            </GenericFormBGContainer>
        </GenericForm>
    )
}